import base from "../utils/base";
const FOAM_API = process.env.REACT_APP_FOAM_BASE_URL;

export default FOAM_API + base;
